import Swiper from 'swiper';
import { swiperObserver } from './swiper.utils';

export const swiperOnResize = (
    breakpoint,
    swiperElement,
    swiperSettings,
    startOnView
) => {
    let swiper;

    breakpoint = window.matchMedia(breakpoint);

    const enableSwiper = function (swiperEl, settings) {
        swiper = new Swiper(swiperEl, settings);

        if (startOnView) {
            swiperObserver(swiper);
        }
    };

    const checker = function () {
        if (breakpoint.matches) {
            return enableSwiper(swiperElement, swiperSettings);
        } else {
            if (swiper !== undefined) swiper.destroy(true, true);
            return;
        }
    };

    breakpoint.addEventListener("change", checker);
    checker();
};